import { useEffect } from 'react';
import { SITE_NAME, SITE_TAGLINE, SITE_DESCRIPTION } from '../config/site';

const DEFAULT_TITLE = `${SITE_NAME} | ${SITE_TAGLINE}`;
const SITE_ORIGIN = typeof window !== 'undefined' ? window.location.origin : '';

export default function usePageMeta({ title, description, canonicalPath } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
    document.title = fullTitle;

    const descTag = document.querySelector('meta[name="description"]');
    if (descTag && description) {
      descTag.setAttribute('content', description);
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', fullTitle);

    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc && description) ogDesc.setAttribute('content', description);

    const path = canonicalPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
    const canonicalUrl = `${SITE_ORIGIN}${path}`;
    let canonicalTag = document.querySelector('link[rel="canonical"]');
    if (!canonicalTag) {
      canonicalTag = document.createElement('link');
      canonicalTag.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalTag);
    }
    canonicalTag.setAttribute('href', canonicalUrl);

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', canonicalUrl);

    return () => {
      document.title = DEFAULT_TITLE;
      if (descTag) descTag.setAttribute('content', SITE_DESCRIPTION);
    };
  }, [title, description, canonicalPath]);
}
